import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { MenuModule } from 'primeng/menu';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { RippleModule } from 'primeng/ripple';
import { MenuItem } from 'primeng/api';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  standalone: true,
  selector: 'app-dashboard-topbar',
  templateUrl: './dashboard-topbar.component.html',
  styleUrl: './dashboard-topbar.component.scss',
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    InputGroupModule,
    InputGroupAddonModule,
    MenuModule,
    AvatarModule,
    BadgeModule,
  RippleModule,
  TranslocoModule
  ]
})
export class DashboardTopbarComponent {
  @Input() isMobile: boolean = false;
  @Output() sidebarToggle = new EventEmitter<void>();

  currentDate = new Date();
  searchValue = '';

  userMenuItems: MenuItem[] = [
    {
      label: 'Profil',
      icon: 'pi pi-user',
      command: () => this.navigateToProfile()
    },
    {
      label: 'Ustawienia',
      icon: 'pi pi-cog',
      command: () => this.navigateToSettings()
    },
    {
      separator: true
    },
    {
      label: 'Wyloguj',
      icon: 'pi pi-sign-out',
      command: () => this.logout()
    }
  ];

  notificationCount = 3;
  userName = 'Jan Kowalski';

  onMenuToggle(): void {
    this.sidebarToggle.emit();
  }

  onSearch(): void {
    if (this.searchValue.trim()) {
      console.log('Searching for:', this.searchValue);
      // Implement search functionality
    }
  }

  onNotificationClick(): void {
    console.log('Opening notifications');
    // Implement notification panel
  }

  private navigateToProfile(): void {
    console.log('Navigate to profile');
    // Implement navigation to profile
  }

  private navigateToSettings(): void {
    console.log('Navigate to settings');
    // Implement navigation to settings
  }

  private logout(): void {
    console.log('Logout');
    // Implement logout functionality
  }

  get formattedDate(): string {
    return this.currentDate.toLocaleDateString('pl-PL', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }
}
